module.exports = __webpack_public_path__ + "img/Menu.71f09294.svg";